import { RECEIPT_CHANNEL_LABELS } from '@chukua/common';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { customerPath } from '../../../../customers/customers.paths';
import { formatReceiptAmount } from '../policies/format-receipt-amount';
import type { ReceiptView } from '../receipts.api';

function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <dt className="text-xs font-medium text-muted">{label}</dt>
      <dd className="mt-1 text-fg">{children}</dd>
    </div>
  );
}

/** Every field of a receipt. Read-only: a receipt is evidence, so a mistake is corrected by a new row, never an edit. */
export function ReceiptDetails({ receipt }: { receipt: ReceiptView }) {
  return (
    <dl className="grid gap-x-8 gap-y-5 sm:grid-cols-2">
      <Field label="Amount">{formatReceiptAmount(receipt)}</Field>
      <Field label="Channel">{RECEIPT_CHANNEL_LABELS[receipt.channel]}</Field>
      <Field label="Customer">
        <Link className="text-link hover:underline" to={customerPath(receipt.customer.id)}>
          {receipt.customer.name}
        </Link>
      </Field>
      <Field label="Reference">{receipt.reference ?? <span className="text-muted">None</span>}</Field>
      <Field label="Received on">{receipt.receivedOn}</Field>
      <Field label="Payer">{receipt.payer}</Field>
      <Field label="Account">{receipt.companyAccount?.name ?? receipt.bankAccount}</Field>
      <Field label="Recorded by">
        {receipt.recordedBy.name}, {new Date(receipt.createdAt).toLocaleString()}
      </Field>
    </dl>
  );
}
